var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-file__holder" }, [
    _c("label", { staticClass: "theme-file", attrs: { for: _vm.id } }, [
      _c(
        "span",
        {
          staticClass:
            "theme-btn theme-btn--theme theme-btn--small theme-file__desktop-btn",
          class: { "theme-file__desktop-btn--white": _vm.white }
        },
        [
          _c("i", {
            staticClass: "icon-upload",
            staticStyle: { "font-size": "20px" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "theme-file__button-text" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.common &&
                    _vm.locales.common.choose_file
                ) +
                "\n      "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "theme-btn theme-btn--theme theme-btn--square theme-btn--square--small theme-file__mobile-btn",
          class: { "theme-file__mobile-btn--white": _vm.white }
        },
        [
          _c("i", {
            staticClass: "icon-upload",
            staticStyle: { "font-size": "20px" }
          })
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "theme-file__text" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.fileName
                ? _vm.fileName
                : _vm.locales &&
                    _vm.locales.common &&
                    _vm.locales.common.no_file_chosen
            ) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("input", {
      ref: _vm.id,
      class: _vm.inputClass,
      staticStyle: { display: "none" },
      attrs: { type: "file", accept: _vm.accept, name: _vm.name, id: _vm.id },
      on: { change: _vm.change }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79c7828a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c7828a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeFile.vue
// module id = 621
// module chunks = 1